export enum ThemeZIndices {
  ModalContent = 'modalContent',
  ModalOverlay = 'modalOverlay',
  Popover = 'popover',
  NavBarPopover = 'navBarPopover',
  WorkbenchHeader = 'workbenchHeader',
}
